import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "cd-user-area" }
const _hoisted_2 = {
  key: 0,
  class: "cd-user-header"
}
const _hoisted_3 = { style: {"display":"flex","align-items":"center","width":"100%"} }
const _hoisted_4 = { style: {"width":"30px","height":"30px","margin-right":"8px"} }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "avatar-placeholder",
  style: {"width":"100%","height":"100%","background-size":"25px"}
}
const _hoisted_7 = {
  class: "data",
  style: {"display":"flex"}
}
const _hoisted_8 = { class: "cd-user-name" }
const _hoisted_9 = {
  class: "svg-inline--fa fa-caret-down fa-w-10",
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "caret-down",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512",
  "data-fa-i2svg": "",
  style: {"color":"white"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserSideMenuV1 = _resolveComponent("UserSideMenuV1")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UserSideMenuV1, { id: "user-sidebar" }),
    (_ctx.cdUserAvailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.profileImageSrc)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.profileImageSrc,
                    alt: "User Avatar",
                    class: "profile-image",
                    style: {"width":"100%","height":"100%","object-fit":"cover","border-radius":"50%"}
                  }, null, 8, _hoisted_5))
                : (_openBlock(), _createElementBlock("div", _hoisted_6))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.currentUser), 1),
              (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("path", {
                  fill: "currentColor",
                  d: "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                }, null, -1)
              ]))]))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}